export default "__VITE_ASSET__DVXfWb2w__"